/**
 * @flow
 * @relayHash 178b7c650b4044fe8d12e76beaeb1ea4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DisallowedPagesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type SitemapFilter = {
  showInSitemap?: ?boolean,
  showNotInSitemap?: ?boolean,
};
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type DisallowedPagesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  sitemapFilter?: ?SitemapFilter,
  sourceUrl?: ?TextFilters,
  url?: ?TextFilters,
|};
export type DisallowedPagesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DisallowedPagesTable_project$ref
  |}
|};
export type DisallowedPagesTable_RefetchQuery = {|
  variables: DisallowedPagesTable_RefetchQueryVariables,
  response: DisallowedPagesTable_RefetchQueryResponse,
|};
*/


/*
query DisallowedPagesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $sitemapFilter: SitemapFilter
  $sourceUrl: TextFilters
  $url: TextFilters
) {
  project(host: $host) {
    ...DisallowedPagesTable_project_WUZyx
    id
  }
}

fragment DisallowedPagesTable_project_WUZyx on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        disallowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, sitemapFilter: $sitemapFilter) {
          count
          edges {
            node {
              ...DisallowedPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DisallowedPagesRow_issue on DisallowedPage {
  id
  type
  severity
  url
  source_url
  sitemap_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sitemapFilter",
    "type": "SitemapFilter",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DisallowedPagesTable_RefetchQuery",
  "id": null,
  "text": "query DisallowedPagesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $sitemapFilter: SitemapFilter\n  $sourceUrl: TextFilters\n  $url: TextFilters\n) {\n  project(host: $host) {\n    ...DisallowedPagesTable_project_WUZyx\n    id\n  }\n}\n\nfragment DisallowedPagesTable_project_WUZyx on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        disallowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, sitemapFilter: $sitemapFilter) {\n          count\n          edges {\n            node {\n              ...DisallowedPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DisallowedPagesRow_issue on DisallowedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  sitemap_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DisallowedPagesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DisallowedPagesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sitemapFilter",
                "variableName": "sitemapFilter",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DisallowedPagesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "disallowedPages",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "sitemapFilter",
                            "variableName": "sitemapFilter",
                            "type": "SitemapFilter"
                          },
                          {
                            "kind": "Variable",
                            "name": "sourceUrl",
                            "variableName": "sourceUrl",
                            "type": "TextFilters"
                          },
                          {
                            "kind": "Variable",
                            "name": "url",
                            "variableName": "url",
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "DisallowedPageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DisallowedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DisallowedPage",
                                "plural": false,
                                "selections": [
                                  v2,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sitemap_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '60b8ae2e71ae98bffca16dfc54237a28';
module.exports = node;
